export const WebChatLayout = {
  OVER_UNDER: "OVER_UNDER",
  SIDE_BY_SIDE: "SIDE_BY_SIDE",
  ONE_BOX: "ONE_BOX",
};

export const BandwidthRestrictions = {
  high: {
    audio: null,
    video: null,
  },
  medium: {
    audio: 256,
    video: 768,
  },
  low: {
    audio: 64,
    video: 448,
  },
};



// WEBPACK FOOTER //
// ./src/types.js